import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const EllipseIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 4 4"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <circle cx={2} cy={2} r={2} fill={color} />
    </svg>
  );
};

export default EllipseIcon;
